module.exports = __webpack_public_path__ + "static/media/Login.7241e580.jpg";